import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { EstateControlService } from 'src/app/services/estate-control.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-step8-complete',
  templateUrl: './step8-complete.component.html',
  styleUrls: ['./step8-complete.component.scss']
})
export class Step8CompleteComponent implements OnInit {
  MileleLogoPath: string  = `${environment.hRef}assets/Milele_logo_white.png`;
  logoPath: string  = `${environment.hRef}assets/logo_w.png`;
  checkerPath: string = `${environment.hRef}assets/fi_check.png`;

  title: string = 'Private Trust created successfully.';
  powerdByText: string = 'Powered by ICEA LION Group. All rights reserved.';

  textH1: string = 'Your Private Trust has been onboarded successfully, with payment of ';
  textH2: string = ' We have also sent a summary of the application details to your email address, ';
  text2: string = 'We are now finalizing the process, and will send a notification within 48 hours.';
  
  buttonText: string = 'Book A Legal Consultation';

  email: string = 'Test@gmail.com';
  amount: string = 'KSH 20,000T';
  
  constructor(
    private readonly estateControlService: EstateControlService,
    private readonly router: Router,
  ) {
  }

  async ngOnInit(): Promise<void> {
    const data  = await this.estateControlService.getData(this.estateControlService.consultationKey);
    await this.estateControlService.clearServiceRecords();
    
    if (data) {
      if (data.Persons?.[0].Email) {
        this.email = data.Persons[0].Email;
      }

      if (data.Amount) {
        if (data.AccountType === 'WillCreation') {
          this.title = 'Will created successfully.';
          this.textH1 = 'Your Will has been created successfully, with payment of ';
        }
        this.amount = `KSH ${Number(data.Amount).toLocaleString()}`;
      }
    }
    else {
      this.goHome();
    }
  }

  async bookAppointment(): Promise<void> {
    const nextPage = `estate-planning/legal-consultaion`;
    this.router.navigate([nextPage]);
  }

  async goHome(): Promise<void> {
    await this.estateControlService.clearServiceRecords();
    const nextPage = ``;
    this.router.navigate([nextPage]);

  }
}
